<!--/**
 * Componente Vue para visualizar un formulario con la informacion que le sea otorgada, esta informacion puede ser un JSON con datos,
 * un simple Array o un String (url) con el recurso a consumir.
 * @version 1.0.0
 * @author Santiago Urrego Giraldo.
 * @since 2017-04-06
 * @param items JSON con los nombres de los campos, label y datos adicionales que se va a mostrar en el formulario
 * Ejemplo:
 * [
 *     {
 *         name: 'first_name',              # name String Nombre del campo que viene en el recurso.
 *         label: 'Nombres',                # label String Nombre del campo para la cabecera.
 *         placeholder: 'ingrese nombre',   # placeholder String texto del campo cuando esta vacio.
 *         maxlength: '30',                 # maxlength int cantidad de caracteres permitidos por el campo.
 *         type: 'text',                    # type String tipo de contenido del campo.
 *         type: 'textarea',                # si el type es textarea se utilizara el control de tipo textarea.
 *              cols:'',                    # int que define la cantidad de columnas que tendra el textarea
 *              rows:'',                    # int que define la cantidad de filas que tendra el textarea
 *         type: 'select',                  # si el type es select se utilizara el control de tipo select.
 *              option:'',                  # string opcion que se visualizara en el select
 *              option.value                # valor de la opcion 
 *              option.text                 # texto de la opcion
 *      }
 * ]
 * Dependiendo el tipo de dato se mostrara el componente respectivo de cada campo al cual se le enviara el objeto actual del ciclo que se recorre para imprimir el formulario con los datos del campo especificamente
 * @param resource String con la url de recurso a consumir.
 * @param updateData Boolean permite mostrar el boton atras y el boton actualizar.
 * @param isLoading Boolean permite ocultar el boton guardar mientras responde el servicio.
 */-->
<template>
    <div method="post" action="" class="form-horizontal" role="form">
        <div class="form-group">
            <div v-for="item, key in itemsFormActivity" v-show="typeof(item.visible)==='undefined' || item.visible === true">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-2'" v-on:email="enabledEmail(item)"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-10'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div v-for="item, key in itemsFormActivityProvider" v-show="typeof(item.visible)==='undefined' || item.visible === true">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-2'" v-on:email="enabledEmail(item)"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-10'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div v-for="item, key in itemsFormActivityClosed" v-show="typeof(item.visible)==='undefined' || item.visible === true">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'" v-on:change="changeList(item)"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-2'" v-on:email="enabledEmail(item)"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div v-for="item, key in itemsFormAccount" v-show="typeof(item.visible)==='undefined' || item.visible === true">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-1'"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div v-for="item, key in itemsFormPqr" v-show="typeof(item.visible)==='undefined' || item.visible === true">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'" v-on:change="changeList(item)"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-1'"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-12'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div v-for="item, key in itemsFormAttachment">
                <div class="clearfix"></div>
                <emt-file v-if="item.type==='file'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-file>
            </div>
            <div v-for="item, key in itemsFormActivityAttachment">
                <div class="clearfix"></div>
                <emt-file v-if="item.type==='file'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-file>
            </div>
            <div v-for="item, key in itemsFormProviderAttachment">
                <div class="clearfix"></div>
                <emt-file v-if="item.type==='file'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-file>
            </div>
            <div v-for="item, key in itemsFormClosedAttachment">
                <div class="clearfix"></div>
                <emt-file v-if="item.type==='file'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-file>
            </div>
            <div v-for="item, key in itemsFormActivityReassignment">
                <emt-input v-if="item.type==='text' || item.type==='number' || item.type==='password'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-input>
                <emt-radio v-if="item.type==='radio'" v-bind:item="item" v-bind:className="'col-md-4'"></emt-radio>
                <emt-select v-if="item.type==='select'" v-bind:item="item" v-bind:className="'col-md-4'" v-on:change="changeList(item)"></emt-select>
                <emt-checkbox v-if="item.type==='checkbox'" v-bind:item="item" v-bind:className="'col-md-1'"></emt-checkbox>
                <emt-textarea v-if="item.type==='textarea'" v-bind:item="item" v-bind:className="'col-md-6'"></emt-textarea>
                <datepicker  v-if="item.type==='date'" language="es" v-on:input="updateDate" :name="item.name" :inputClass="item.class" :wrapperClass="item.divclass" :placeholder="item.placeholder" format="yyyy-MM-dd"></datepicker>
                <div v-if="(key + 1) % 3 === 0" class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <br>
            <div class="col-md-12 text-center">
                 <div v-if="itemsFormPqr">
                    <div v-if="this.typeactivity==='register'">
                        <input v-if="!isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="register">
                        <span v-else>Cargando...</span>
                    </div>
                 </div>
                <div v-if="itemsFormActivity">
                    <div v-if="this.typeactivity==='scaled'">
                        <input v-if="!isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="registerActivity">
                        <span v-else>Cargando...</span>
                    </div>
                 </div>
                <div v-if="itemsFormActivityProvider">
                    <div v-if="this.typeactivity==='waiting_provider'">
                        <input v-if="!isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="registerActivityProvider">
                        <span v-else>Cargando...</span>
                    </div>
                 </div>
                <div v-if="itemsFormActivityClosed">
                    <div v-if="this.typeactivity==='pending' && Cookies.get('perfil') !== 'Epm'">
                        <input v-if="!isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="registerActivityClosed">
                        <span v-else>Cargando...</span>
                    </div>
                 </div>
                 <div v-if="itemsFormActivityReassignment">
                    <div v-if="this.typeactivity==='reassignment'">
                        <input v-if="!isLoading" type="button" class="btn btn-success" value="Guardar" name="Guardar" v-on:click="reassignmentActivityPQR">
                        <span v-else>Cargando...</span>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import Datepicker from 'vuejs-datepicker'
import router from '@/router'
import Config from '@/config'
import EmtInput from '@/components/input-components/emt-input'
import EmtCheckbox from '@/components/input-components/emt-checkbox'
import EmtRadio from '@/components/input-components/emt-radio'
import EmtSelect from '@/components/input-components/emt-select'
import EmtTextarea from '@/components/input-components/emt-textarea'
import EmtFile from '@/components/input-components/emt-file'
import swal from 'sweetalert2'

export default {
    name: 'emt-form-pqr',
    data: function () {
        return {
            data: {
                form_valuesPqr: {},
                form_valuesAccount: {},
                form_valuesAttachment: {},
                form_valuesActivity: {},
                form_valuesActivityAttachment: {},
                form_valuesActivityProvider: {},
                form_valuesProviderAttachment: {},
                form_valuesActivityClosed: {},
                form_valuesClosedAttachment: {},
                form_valuesActivityReassignment: {},
                errors: []
            },
            Cookies: Cookies,
            isLoading: false
        }
    },
    props: {
        resource: Array,
        itemsFormAccount: Array,
        itemsFormPqr: Array,
        itemsFormAttachment: Array,
        itemsFormActivity: Array,
        itemsFormActivityAttachment: Array,
        itemsFormActivityProvider: Array,
        itemsFormProviderAttachment: Array,
        itemsFormActivityClosed: Array,
        itemsFormClosedAttachment: Array,
        itemsFormActivityReassignment: Array,
        typeactivity: String,
        updateData: Boolean
    },
    methods: {
        getFormValuesAccount: function () {
            var self = this
            self.data.form_valuesAccount = {}
            for (var i = 0; i < self.itemsFormAccount.length; i++) {
                var value = null
                if (typeof self.itemsFormAccount[i].value === 'string') {
                    value = self.itemsFormAccount[i].value != null ? self.itemsFormAccount[i].value.trim() : null
                } else {
                    value = self.itemsFormAccount[i].value
                }
                self.data.form_valuesAccount[self.itemsFormAccount[i].name] = value
            }
            return self.data.form_valuesAccount
        },
        getFormValuesPQR: function () {
            var self = this
            self.data.form_valuesPqr = {}
            for (var i = 0; i < self.itemsFormPqr.length; i++) {
                var value = null
                if (typeof self.itemsFormPqr[i].value === 'string') {
                    value = self.itemsFormPqr[i].value != null ? self.itemsFormPqr[i].value.trim() : null
                } else {
                    value = self.itemsFormPqr[i].value
                }
                self.data.form_valuesPqr[self.itemsFormPqr[i].name] = value
            }
            return self.data.form_valuesPqr
        },
        getFormValuesAttachment: function () {
            var self = this
            self.data.form_valuesAttachment = []
            for (var i = 0; i < self.itemsFormAttachment[0].value.length; i++) {
                self.data.form_valuesAttachment.push(self.itemsFormAttachment[0].value[i])
            }
            return self.data.form_valuesAttachment
        },
        getFormValuesActivityAttachment: function () {
            var self = this
            self.data.form_valuesActivityAttachment = []
            for (var i = 0; i < self.itemsFormActivityAttachment[0].value.length; i++) {
                self.data.form_valuesActivityAttachment.push(self.itemsFormActivityAttachment[0].value[i])
            }
            return self.data.form_valuesActivityAttachment
        },
        getFormValuesProviderAttachment: function () {
            var self = this
            self.data.form_valuesProviderAttachment = []
            for (var i = 0; i < self.itemsFormProviderAttachment[0].value.length; i++) {
                self.data.form_valuesProviderAttachment.push(self.itemsFormProviderAttachment[0].value[i])
            }
            return self.data.form_valuesProviderAttachment
        },
        getFormValuesClosedAttachment: function () {
            var self = this
            self.data.form_valuesClosedAttachment = []
            for (var i = 0; i < self.itemsFormClosedAttachment[0].value.length; i++) {
                self.data.form_valuesClosedAttachment.push(self.itemsFormClosedAttachment[0].value[i])
            }
            return self.data.form_valuesClosedAttachment
        },
        getFormValuesActivity: function () {
            var self = this
            self.data.form_valuesActivity = {}
            for (var i = 0; i < self.itemsFormActivity.length; i++) {
                var value = null
                if (typeof self.itemsFormActivity[i].value === 'string') {
                    value = self.itemsFormActivity[i].value != null ? self.itemsFormActivity[i].value.trim() : null
                } else {
                    value = self.itemsFormActivity[i].value
                }
                self.data.form_valuesActivity[self.itemsFormActivity[i].name] = value
            }
            return self.data.form_valuesActivity
        },
        getFormValuesActivityProvider: function () {
            var self = this
            self.data.form_valuesActivityProvider = {}
            for (var i = 0; i < self.itemsFormActivityProvider.length; i++) {
                var value = null
                if (typeof self.itemsFormActivityProvider[i].value === 'string') {
                    value = self.itemsFormActivityProvider[i].value != null ? self.itemsFormActivityProvider[i].value.trim() : null
                } else {
                    value = self.itemsFormActivityProvider[i].value
                }
                self.data.form_valuesActivityProvider[self.itemsFormActivityProvider[i].name] = value
            }
            return self.data.form_valuesActivityProvider
        },
        getFormValuesActivityClosed: function () {
            var self = this
            self.data.form_valuesActivityClosed = {}
            for (var i = 0; i < self.itemsFormActivityClosed.length; i++) {
                var value = null
                if (typeof self.itemsFormActivityClosed[i].value === 'string') {
                    value = self.itemsFormActivityClosed[i].value != null ? self.itemsFormActivityClosed[i].value.trim() : null
                } else {
                    value = self.itemsFormActivityClosed[i].value
                }
                self.data.form_valuesActivityClosed[self.itemsFormActivityClosed[i].name] = value
            }
            return self.data.form_valuesActivityClosed
        },
        getFormValuesReassignment: function () {
            var self = this
            self.data.form_valuesActivityReassignment = {}
            for (var i = 0; i < self.itemsFormActivityReassignment.length; i++) {
                var value = null
                if (typeof self.itemsFormActivityReassignment[i].value === 'string') {
                    value = self.itemsFormActivityReassignment[i].value != null ? self.itemsFormActivityReassignment[i].value.trim() : null
                } else {
                    value = self.itemsFormActivityReassignment[i].value
                }
                self.data.form_valuesActivityReassignment[self.itemsFormActivityReassignment[i].name] = value
            }
            return self.data.form_valuesActivityReassignment
        },
        register: function () {
            var self = this
            self.isLoading = true
            var valuesAccount = self.getFormValuesAccount()
            var valuesPQR = self.getFormValuesPQR()
            var valuesAttachment = self.getFormValuesAttachment()
            var values = {}
            values['account'] = valuesAccount
            values['pqr'] = valuesPQR
            var arrayAttachment = []
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {}
                itemAttachment['name'] = valuesAttachment[i].name
                itemAttachment['attachment'] = valuesAttachment[i].asBase64
                arrayAttachment.push(itemAttachment)
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment
            }
            self.$http.post(Config.create_pqr, values).then(function (response) {
                swal({
                    title: 'Se guardó la PQR exitosamente',
                    text: 'Con el ID: ' + response.body.id,
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.push('/ConsultPqr')
                self.isLoading = false
            }, function (response) {
                self.data.errors = response.body.detail
                if (response.status === 423) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                    self.isLoading = false
                } else {
                    self.isLoading = false
                    var prop = null
                    /* agregar arreglo de errores por formulario */
                    for (var i in self.itemsFormAccount) {
                        self.itemsFormAccount[i].errors = []
                    }
                    for (i in self.itemsFormPqr) {
                        self.itemsFormPqr[i].errors = []
                    }
                    for (i in self.itemsFormAttachment) {
                        self.itemsFormAttachment[i].errors = []
                    }
                    /* Asignacion de errores */
                    for (i in self.itemsFormAccount) {
                        for (prop in self.data.errors) {
                            if (self.itemsFormAccount[i].name === prop) {
                                self.itemsFormAccount[i].errors = response.body.detail[prop]
                            }
                        }
                    }
                    for (i in self.itemsFormPqr) {
                        for (prop in self.data.errors) {
                            if (self.itemsFormPqr[i].name === prop) {
                                self.itemsFormPqr[i].errors = response.body.detail[prop]
                            }
                        }
                    }
                    for (i in self.itemsFormAttachment) {
                        self.itemsFormAttachment[i].errors = response.body.file
                    }
                    /* error general */
                    for (prop in self.data.errors) {
                        swal({
                            title: 'Se ha presentado un error.',
                            text: self.data.errors[prop],
                            type: 'error',
                            confirmButtonText: 'Aceptar'
                        })
                    }
                }
            })
        },
        registerActivity: function () {
            var self = this
            var values = self.getFormValuesActivity()
            var valuesAttachment = self.getFormValuesActivityAttachment()
            values['pqr'] = Config.api + '/pqr/' + this.$route.params.id + '/'
            values['status'] = 'PENDING'
            values['section'] = 'EPM'
            values['file'] = null
            var arrayAttachment = []
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {}
                itemAttachment['name'] = valuesAttachment[i].name
                itemAttachment['attachment'] = valuesAttachment[i].asBase64
                arrayAttachment.push(itemAttachment)
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment
            }
            self.$http.post(Config.api + self.resource[0].resourceActivity, values).then(function (response) {
                swal({
                    title: 'Se actualizó la PQR exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.push('/ConsultPqr')
                self.isLoading = false
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                if (self.data.errors.detail) {
                    self.data.errors = JSON.parse(self.data.errors.detail[0].split('\'').join('"'))
                }
                for (var i in self.itemsFormActivity) {
                    self.itemsFormActivity[i].errors = []
                }
                for (i in self.itemsFormActivity) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivity[i].name === prop) {
                            self.itemsFormActivity[i].errors = self.data.errors[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
        },
        registerActivityProvider: function () {
            var self = this
            var values = self.getFormValuesActivityProvider()
            var valuesAttachment = self.getFormValuesProviderAttachment()
            values['pqr'] = Config.api + '/pqr/' + this.$route.params.id + '/'
            values['status'] = 'PENDING'
            values['waiting_provider'] = false
            values['section'] = 'provider'
            values['file'] = null
            var arrayAttachment = []
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {}
                itemAttachment['name'] = valuesAttachment[i].name
                itemAttachment['attachment'] = valuesAttachment[i].asBase64
                arrayAttachment.push(itemAttachment)
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment
            }
            self.$http.post(Config.api + self.resource[0].resourceActivity, values).then(function (response) {
                swal({
                    title: 'Se actualizó la PQR exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.push('/ConsultPqr')
                self.isLoading = false
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                if (self.data.errors.detail) {
                    self.data.errors = JSON.parse(self.data.errors.detail[0].split('\'').join('"'))
                }
                for (var i in self.itemsFormActivityProvider) {
                    self.itemsFormActivityProvider[i].errors = []
                }
                for (i in self.itemsFormActivityProvider) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivityProvider[i].name === prop) {
                            self.itemsFormActivityProvider[i].errors = self.data.errors[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
        },
        registerActivityClosed: function () {
            var self = this
            var values = self.getFormValuesActivityClosed()
            var valuesAttachment = self.getFormValuesClosedAttachment()
            values['pqr'] = Config.api + '/pqr/' + this.$route.params.id + '/'
            values['status'] = 'CLOSED'
            values['note'] = 'cierre'
            values['waiting_provider'] = false
            values['section'] = 'closed'
            values['file'] = null
            var arrayAttachment = []
            for (var i = 0; i < valuesAttachment.length; i++) {
                var itemAttachment = {}
                itemAttachment['name'] = valuesAttachment[i].name
                itemAttachment['attachment'] = valuesAttachment[i].asBase64
                arrayAttachment.push(itemAttachment)
            }
            if (arrayAttachment.length > 0) {
                values['file'] = arrayAttachment
            }
            self.$http.post(Config.api + self.resource[0].resourceActivity, values).then(function (response) {
                swal({
                    title: 'Se realizó el cierre exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.push('/ConsultPqr')
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                self.data.errors = JSON.parse(self.data.errors.detail[0].split('\'').join('"'))
                for (var i in self.itemsFormActivityClosed) {
                    self.itemsFormActivityClosed[i].errors = []
                }
                for (i in self.itemsFormActivityClosed) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivityClosed[i].name === prop) {
                            self.itemsFormActivityClosed[i].errors = self.data.errors[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    swal({
                        title: 'Se ha presentado un error.',
                        text: self.data.errors.detail,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
            self.isLoading = false
        },
        reassignmentActivityPQR: function () {
            var self = this
            var values = self.getFormValuesReassignment()
            values['pqr'] = Config.api + '/pqr/' + this.$route.params.id + '/'
            values['status'] = 'SCALED'
            values['section'] = 'reassignment'
            values['reassigned'] = true
            values['user_from'] = Config.api + '/user/' + Cookies.get('idUser') + '/'
            values['file'] = {}
            self.$http.post(Config.api + self.resource[0].resourceActivity, values).then(function (response) {
                swal({
                    title: 'Se actualizó la PQR exitosamente',
                    text: '',
                    type: 'success',
                    confirmButtonText: 'Aceptar'
                })
                router.push('/ConsultPqr')
                self.isLoading = false
            }, function (response) {
                self.data.errors = response.body
                self.isLoading = false
                var prop = null
                for (var i in self.itemsFormActivityReassignment) {
                    self.itemsFormActivityReassignment[i].errors = []
                }
                for (i in self.itemsFormActivityReassignment) {
                    for (prop in self.data.errors) {
                        if (self.itemsFormActivityReassignment[i].name === prop) {
                            self.itemsFormActivityReassignment[i].errors = response.body[prop]
                        }
                    }
                }
                for (prop in self.data.errors.detail) {
                    var message = JSON.parse(self.data.errors.detail[0].split('\'').join('"')).detail[0]
                    swal({
                        title: 'Se ha presentado un error.',
                        text: message,
                        type: 'error',
                        confirmButtonText: 'Aceptar'
                    })
                }
            })
        },
        changeList: function (item) {
            this.$emit('change', item)
        },
        enabledEmail: function (item) {
            this.$emit('changeEmail', item)
        }
        /* listener: function (e) {
            var self = this
            if (e.key === 'Enter') {
                if (self.typeactivity === 'register') {
                    self.register()
                }
                if (self.typeactivity === 'scaled') {
                    self.registerActivity()
                }
                if (self.typeactivity === 'waiting_provider') {
                    self.registerActivityProvider()
                }
                if (self.typeactivity === 'pending') {
                    self.registerActivityClosed()
                }
            }
        } */
    },
    /* mounted: function () {
        var self = this
        window.addEventListener('keyup', self.listener)
    },
    destroyed: function () {
        var self = this
        window.removeEventListener('keyup', self.listener)
    }, */
    components: {
        'emt-input': EmtInput,
        'emt-checkbox': EmtCheckbox,
        'emt-radio': EmtRadio,
        'emt-select': EmtSelect,
        'emt-textarea': EmtTextarea,
        'emt-file': EmtFile,
        'datepicker': Datepicker
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-pqr.vue?78aac345